import { render, staticRenderFns } from "./ModernInfinityDimensionsTab.vue?vue&type=template&id=4fbc28ac&"
import script from "./ModernInfinityDimensionsTab.vue?vue&type=script&lang=js&"
export * from "./ModernInfinityDimensionsTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports